import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../lib/api';
import type { ScheduleGridResponse } from '../lib/types';

export function useMySchedule(days = 90) {
  return useQuery({
    queryKey: ['my-schedule', days],
    queryFn: () => apiClient.get<ScheduleGridResponse>(`/api/me/schedule?days=${days}`),
  });
}
